export default __webpack_public_path__ + "static/media/create-automation-1.63fd77f4.png";